module.exports = __webpack_public_path__ + "components/rewards/armadillo/static/logo-c7297649f7a2dd3268e7fad66c1df793.jpg";